export default __webpack_public_path__ + "static/media/Frescas-Sandy.b3a6b412.jpg";